import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';

import { TextPositioner } from '../primitives/TextPositioner';

type Props = {
  item: GridCard<
    | PlaneTypes.Card_MultiSection_Description
    | PlaneTypes.Card_MultiSection_Description_Body_Small
    | PlaneTypes.Card_MultiSection_Description_Body_Ultra_Small
    | PlaneTypes.Card_MultiSection_SectionHero_Small_Description
  >;
};

export const MultiSectionDescriptionBody = observer(
  function MultiSectionDescriptionBody({ item }: Props) {
    const getTextProps = (): CardTextProps => {
      if (item.type === PlaneTypes.Card_MultiSection_Description) {
        return {
          text: item.data?.body ?? '',
          fontSize: 18,
          fontAsset: Assets.Font_Gilroy_SemiBold,
          lineHeight: 22 / 18,
          color: 'black',
          anchorX: 'left',
          anchorY: 'top',
          textAlign: 'left',
          maxWidth: item.size.width - 150,
          letterSpacing: 0.03,
          position: {
            x: -item.size.width / 2 + 150 / 2,
            y: item.size.height / 2,
          },
        };
      }

      if (item.type === PlaneTypes.Card_MultiSection_Description_Body_Small) {
        return {
          text: item.data?.body ?? '',
          fontSize: 18,
          lineHeight: 22 / 18,
          letterSpacing: 0.03,
          fontAsset: Assets.Font_Gilroy_SemiBold,
          color: 'black',
          anchorX: 'left',
          anchorY: 'middle',
          textAlign: 'left',
          maxWidth: item.size.width - 20,
          position: {
            x: -item.size.width / 2 + 20 / 2,
            y: -40,
          },
        };
      }

      if (
        item.type === PlaneTypes.Card_MultiSection_SectionHero_Small_Description
      ) {
        return {
          text: item.data?.body ?? '',
          fontSize: 14,
          fontAsset: Assets.Font_Gilroy_Medium,
          color: 'black',
          anchorX: 'left',
          anchorY: 'top',
          textAlign: 'left',
          lineHeight: 18 / 14,
          maxWidth: item.size.width - 20,
          letterSpacing: 0.03,
          position: {
            x: -item.size.width / 2 + 20 / 2,
            y: item.size.height / 2 + 10,
          },
        };
      }

      // Card_MultiSection_Description_Body_Ultra_Small

      return {
        text: item.data?.body ?? '',
        fontSize: 14,
        fontAsset: Assets.Font_Gilroy_SemiBold,
        color: 'black',
        anchorX: 'left',
        anchorY: 'top',
        textAlign: 'left',
        lineHeight: 18 / 14,
        maxWidth: item.size.width - 20,
        position: {
          x: -item.size.width / 2 + 20 / 2,
          y: item.size.height / 2 - 10,
        },
      };
    };

    const textProps = getTextProps();
    if (!textProps.text) {
      return null;
    }

    return (
      <TextPositioner item={item}>
        <CardText {...textProps} />
      </TextPositioner>
    );
  }
);
